<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits(['create']);

const { t } = useI18n();
const showActionsDropdown = ref(false);

const menuItems = [
  {
    label: t('COMPANIES.ACTIONS.CREATE'),
    action: 'create',
    value: 'create',
    icon: 'i-lucide-plus',
  },
];

const handleAction = ({ action }) => {
  if (action === 'create') emit('create');
  showActionsDropdown.value = false;
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      class="!size-9 !rounded-lg !bg-auth-soft !text-auth-muted hover:!bg-auth-border hover:!text-auth-text dark:!bg-auth-soft-dark dark:!text-auth-muted-dark dark:hover:!bg-auth-border-dark dark:hover:!text-auth-text-dark"
      :class="
        showActionsDropdown ? '!bg-auth-border dark:!bg-auth-border-dark' : ''
      "
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="menuItems"
      class="end-0 top-full mt-2 w-52 !border-auth-border !bg-auth-surface !text-auth-text shadow-lg shadow-auth-brand/10 dark:!border-auth-border-dark dark:!bg-auth-surface-dark dark:!text-auth-text-dark"
      @action="handleAction($event)"
    />
  </div>
</template>
